/**
 * Contador regressivo do token (MV2-1715).
 *
 * Calculado a partir do expires_at devolvido pela API, e nunca de um TTL
 * contado no cliente: recarregar a tela ou demorar para copiar não pode
 * "renovar" o prazo. O relógio do servidor é a verdade.
 */

export type Countdown = {
  expired: boolean;
  /** Formato d hh:mm:ss, sem o dia quando não há. */
  text: string;
};

const pad = (value: number): string => String(value).padStart(2, '0');

export const countdownFrom = (expiresAt: string, now: Date = new Date()): Countdown => {
  const remaining = new Date(expiresAt).getTime() - now.getTime();

  if (Number.isNaN(remaining) || remaining <= 0) {
    return { expired: true, text: '00:00:00' };
  }

  const totalSeconds = Math.floor(remaining / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const clock = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;

  return { expired: false, text: days > 0 ? `${days}d ${clock}` : clock };
};
